import { PrimaryButton } from "@shared/buttons";

interface Props {
  level: number;
  onLoadMoreClicked: () => void;
}

export const LoadMoreButtonCell = ({ level, onLoadMoreClicked }: Props) => {
  return (
    <div className="h-full px-2 flex items-center gap-1 load-more-row">
      {Array(level)
        .fill(null)
        .map((_, index) => (
          <div key={index} className="shrink-0 w-4" />
        ))}
      <PrimaryButton
        size="sm"
        className="h-7 text-xs"
        onClick={() => onLoadMoreClicked()}
      >
        Load more
      </PrimaryButton>
    </div>
  );
};

export const LoadMorePlaceholderCell = () => {
  return <div className="h-full px-2 flex items-center load-more-row"></div>;
};
